function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.281 6.387L4 9.739a.65.65 0 0 1-1-.533V2.477a.65.65 0 0 1 1-.533l5.281 3.365a.65.65 0 0 1 0 1.078z",
  className: "cls-1",
  transform: "translate(-3 -1.842)"
});

var SvgExpander = function SvgExpander(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 6.568,
    height: 8,
    viewBox: "0 0 6.568 8",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExpander, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjU2OCIgaGVpZ2h0PSI4IgogICAgIHZpZXdCb3g9IjAgMCA2LjU2OCA4Ij4KICA8cGF0aAogICAgZD0iTTkuMjgxIDYuMzg3TDQgOS43MzlhLjY1LjY1IDAgMCAxLTEtLjUzM1YyLjQ3N2EuNjUuNjUgMCAwIDEgMS0uNTMzbDUuMjgxIDMuMzY1YS42NS42NSAwIDAgMSAwIDEuMDc4eiIKICAgIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTEuODQyKSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };